import React from 'react'
import { connect } from "react-redux"
import { withRouter, Link } from 'react-router'
import sortBy from 'lodash/sortBy'

import * as types from '../../constants/ActionTypes';
import Avatar from '../user/Avatar'

import { setTitle } from "../../actions/index"
import { fetchParentPatientRecords } from '../../actions/parent'
@connect((store) => {
	return {
		User: store.User.User,
		app: store.app,
		patients: store.patients,
		practices: store.practices,
		patient_records: store.patient_records
	}
})
class ParentDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'gotPatients': false
		}
		this.showPatientRecordChoices = this.showPatientRecordChoices.bind(this)
		this.setPractices = this.setPractices.bind(this);
		this.selectPatientRecord = this.selectPatientRecord.bind(this)
		this.setup = this.setup.bind(this)
	}

	componentWillMount() {
		let { dispatch } = this.props;
		dispatch(setTitle('Parent Dashboard'));
		this.setup();
	}

	setup() {
		let { dispatch, User } = this.props;
		dispatch({
			type: types.SET_PATIENT_RECORDS,
			payload: []
		})
		dispatch(fetchParentPatientRecords(User._id))
			.then(patient_records => {
				this.setState({ 'gotPatient': true })
				if (patient_records.length === 1) {
					this.selectPatientRecord(patient_records[0])
				} else {
					this.setPractices();
				}
			}).catch(err => {
				console.log(err);
			})
	}

	componentDidUpdate(nextProps) {
		let { dispatch } = this.props;
		if (nextProps.app.authed && !this.props.app.authed) {
			this.setState({
				'gotPatients': false
			});
			dispatch({
				type: types.SET_PATIENT_RECORDS,
				payload: []
			})
			this.setup()
		}

		// console.log('User',this.props.User);
		if (this.props.User.name != nextProps.User.name) {
			console.log('Update');
			this.setup()
		}
	}

	selectPatientRecord(patientRecord) {
		let { router, User } = this.props;
		router.push(`/parents/${User._id}/patient_record/${patientRecord._id}`);
	}

	setPractices() {
	}

	showPatientRecordChoices() {
		let { patient_records, User } = this.props;
		let { gotPatients } = this.state;
		let patient_records_array = Object.values(patient_records);

		if (patient_records_array.length) {
			return <div className="video-grid ">
				
				{/*<h1>Patients of { User.displayName }</h1>*/}
				<h1>VIEW THE FOLLOWING PATIENT NOTES</h1>
				{sortBy(patient_records_array, ['patient.firstName']).map((patient_record, i) => {

					return <div key={patient_record._id} className="link"
						onClick={() => { this.selectPatientRecord(patient_record) }}>
						<div className="card">
							{/* <div className={"card-header row " + (i % 3)}>
								{patient_record.patient.firstName} {patient_record.patient.lastName}
							</div> */}
							<div className="padding ">
									<div className="row">
										{patient_record.patient.picture ? <Avatar pic={`${patient_record.patient.picture.thumb}`} /> : <Avatar pic='/public/images/user.png' />}
										<div>&nbsp;</div>
										{/* <Avatar pic={patient_record.therapist.photoUrl} /> */}
									</div>
							</div>
							<div className="card-content row">
								<div className="dont-shrink fill ">
								{patient_record.patient.firstName} {patient_record.patient.lastName}
									<p>Therapist: {patient_record.therapist.name}</p>
									{patient_record.practice ? <p>
										Practice: <Link to={`/practice/${patient_record.practice.slug}`}
											onClick={(e) => { e.stopPropagation() }}>{patient_record.practice.name}</Link>
									</p> : null}
								</div>

								
							</div>
						</div>
					</div>
				}
				)}
			</div>
		}
		return gotPatients ? <p>There are no assessments yet</p> : <p>Getting assessments...</p>;
	}

	render() {
		let { patient_records } = this.props;
		return <main className="main parentDashboard">
			{patient_records.length !== 1 && this.showPatientRecordChoices()}
		</main>
	}
}



export default withRouter(ParentDashboard);



// WEBPACK FOOTER //
// ./src/components/parent/ParentDashboard.jsx